import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComponentHostDirective } from './component-host.directive';
import { DynamicComponentService } from './dynamic-component.service';
import { ErrorHandlerService } from './error-handler.service';
import { DecoratorService } from './decorator.service';
import { Log } from '../services/logger.service';

@NgModule({
  declarations: [
    ComponentHostDirective,
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    ComponentHostDirective,
    CommonModule,
    FormsModule
  ],
  providers: [
    Log,
    DecoratorService,
    ErrorHandlerService,
    DynamicComponentService,
  ]
})
export class DecoratorModule { }
